import { SubSink } from 'subsink';
import * as moment from 'moment';
import { isEmpty } from 'lodash';
import { TemplateService } from '../../../services/template.service';
import * as _ from 'lodash';
import { CALENDAR_LOCALE } from '../../../services/constant';
import { DownloadService } from '../download.service';
import { TranslateService } from '@ngx-translate/core';
var DownloadRequestIncComponent = (function () {
    function DownloadRequestIncComponent(downloadService, template, translate) {
        this.downloadService = downloadService;
        this.template = template;
        this.translate = translate;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.startDate = new Date(moment().format('YYYY') + '-01-01');
        this.endDate = new Date(moment().format('YYYY') + '-12-30');
        this.taxID = '';
        this.documentNumber = '';
        this.email = '';
        this.isSuccess = false;
        this.loading = false;
        this.error = {};
        this.requestType = 0;
        this.allDocumentType = [];
        this.subs = new SubSink();
    }
    DownloadRequestIncComponent.prototype.ngOnInit = function () {
        var _this = this;
        // this.loadInput();
        // this.loadDropdown();
        this.translate.onLangChange.subscribe(function (event) {
            _this.loadTexts();
        });
        this.loadTexts();
        this.rdDocumentType = this.template.getDropdown();
    };
    DownloadRequestIncComponent.prototype.loadTexts = function () {
        this.tableCol = [];
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
    };
    Object.defineProperty(DownloadRequestIncComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = new Date().getFullYear();
            return thisYear - 40 + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DownloadRequestIncComponent.prototype, "dateRange", {
        get: function () {
            var start = moment(this.startDate).format('DD/MM/YYYY');
            var end = moment(this.endDate).format('DD/MM/YYYY');
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    DownloadRequestIncComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
        if (this.endDate < this.minDate) {
            this.endDate = this.minDate;
        }
    };
    DownloadRequestIncComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
        if (this.startDate > this.maxDate) {
            this.startDate = this.maxDate;
        }
    };
    DownloadRequestIncComponent.prototype.validateEmail = function (email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };
    DownloadRequestIncComponent.prototype.validateTaxID = function (taxID) {
        if (taxID == null || taxID === '') {
            return true;
        }
        return this.taxID.length === 13;
    };
    DownloadRequestIncComponent.prototype.validateInput = function () {
        this.validateEmail(this.email) === false
            ? (this.error['email'] = true)
            : delete this.error['email'];
        return this.error;
    };
    DownloadRequestIncComponent.prototype.submit = function () {
        var _this = this;
        this.error = {};
        var errorField = [];
        this.errorMessage = null;
        if (this.translate.currentLang === 'en') {
            if (!isEmpty(this.validateInput())) {
                errorField.push('Email is invalid form. It needs to be in xxx@xxx.com form only.');
            }
            if (this.buyerName == null || this.buyerName.length == 0) {
                errorField.push('buyer name ');
            }
            if (this.documentNumber == null || this.documentNumber.length == 0) {
                errorField.push('document number ');
            }
            if (this.selectedRdDocumentType == undefined) {
                errorField.push('document Type');
            }
            if (errorField.length > 0) {
                this.errorMessage = 'Please fill ' + errorField.join(',') + ' correctly.';
                return;
            }
        }
        else {
            if (!isEmpty(this.validateInput())) {
                errorField.push('อีเมล์ไม่ถูกต้อง ต้องระบุอีเมล์ในรูปแบบของ xxx@xxx.com เท่านั้น');
            }
            if (this.buyerName == null || this.buyerName.length == 0) {
                errorField.push('ชื่อผู้ซื้อ');
            }
            if (this.documentNumber == null || this.documentNumber.length == 0) {
                errorField.push('เลขที่เอกสาร');
            }
            if (this.selectedRdDocumentType == undefined) {
                errorField.push('ประเภทเอกสาร');
            }
            if (errorField.length > 0) {
                this.errorMessage = 'โปรดกรอก' + errorField.join(', ') + ' ให้ครบถ้วน';
                return;
            }
        }
        // this.company_type = '';
        // if (this.requestType === 1) {
        //   this.company_type = 'IQVIA INC. - Thailand';
        // }else {
        //   this.company_type = 'IQVIA (Thailand) Co., Ltd.';
        // }
        var data = {
            rd_doc_type: this.selectedRdDocumentType,
            buyer_name: this.buyerName,
            document_number: this.documentNumber,
            document_type_id: _.isNil(this.documentType)
                ? this.documentType
                : _.uniq(this.allDocumentType),
            document_start_date: this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : '',
            document_end_date: this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : '',
            email: this.email,
            seller_name: 'IQVIA INC. - Thailand'
        };
        this.loading = true;
        this.downloadService.createDocumentRequest(data).subscribe(function () {
            _this.isSuccess = true;
            _this.loading = false;
        });
    };
    DownloadRequestIncComponent.prototype.reloadPage = function () {
        location.reload();
    };
    DownloadRequestIncComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return DownloadRequestIncComponent;
}());
export { DownloadRequestIncComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download-request-inc/download-request-inc.component.ts.pre-build-optimizer.js